/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/core';

import Arrow from '../Icons/Arrow';

const SlickButtonFix = ({ primaryColor, uiVariant, children, props }) => {
  const arrowStyle = css`
     {
      color: #7b7b7b;
      z-index: 1000;

      &.slick-prev {
        svg {
          transform: rotate(180deg);
        }
      }

      &.slick-disabled {
        svg {
          background-color: #d4d4d4;
        }
        &:hover svg {
          background-color: #d4d4d4;
        }
      }

      &:before {
        visibility: hidden;
      }

      svg {
        color: #fff;
        background-color: ${primaryColor};
        border-radius: ${uiVariant === '1'
          ? '12px'
          : uiVariant === '3'
          ? '50%'
          : 0};

        &:focus,
        &:hover,
        &.active {
          opacity: 0.7;
        }
      }
    }
  `;

  return (
    <span
      css={arrowStyle}
      {...props}
    >
      {children}
    </span>
  );
};

const SlickArrow = ({ primaryColor, uiVariant, ...props }) => {
  return (
    <SlickButtonFix
      primaryColor={primaryColor}
      uiVariant={uiVariant}
      props={props}
    >
      <span>
        <Arrow />
      </span>
    </SlickButtonFix>
  );
};

export default SlickArrow;
